/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Maximize2 } from 'lucide-react';
import { BaseCardHeader } from './base-card-header';

interface ImageCardHeaderProps {
  title: string;
  backgroundColor?: string;
  sourceUrl: string;
  relevanceValue: number;
  groupedCards?: any[];
  currentCardIndex: number;
  onClose: () => void;
  onImageExpand: () => void;
}

export const ImageCardHeader: React.FC<ImageCardHeaderProps> = ({
  sourceUrl,
  onImageExpand,
  ...baseProps
}) => {
  const renderImageContent = () => (
    <>
      <div className='h-full w-full overflow-hidden'>
        <img
          className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
          src={sourceUrl || '/images/placeholders/image-place-holder.png'}
          alt={baseProps.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'left top',
          }}
        />
      </div>

      <button
        className='absolute left-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-white opacity-0 transition-opacity hover:bg-black/60 group-hover:opacity-100'
        onClick={onImageExpand}
        aria-label='Expand image'
      >
        <Maximize2 size={18} />
      </button>
    </>
  );

  return (
    <BaseCardHeader {...baseProps as ImageCardHeaderProps}>
      {renderImageContent()}
    </BaseCardHeader>
  );
};
